import React, { useState, useRef, useEffect } from "react";
import { Globe, ChevronDown } from "lucide-react";
import { useI18n, LANGUAGES } from "@/context/I18nContext";

export default function LanguageSwitcher({ variant = "default" }) {
  const { lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const current = LANGUAGES.find((l) => l.code === lang) || LANGUAGES[0];

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="lang-switcher-button"
        onClick={() => setOpen((o) => !o)}
        className={`flex items-center gap-1.5 px-2.5 sm:px-3 py-2 border border-[#2A2E38] text-[#A3A9B8] rounded-sm hover:border-[#7C5CFF] hover:text-[#7C5CFF] transition-colors text-xs font-mono ${
          variant === "ghost" ? "border-transparent" : ""
        }`}
        aria-label="Change language"
      >
        <Globe size={14} />
        <span>{current.label}</span>
        <ChevronDown size={12} className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div
          data-testid="lang-switcher-menu"
          className="absolute right-0 mt-2 w-36 bg-[#141720] border border-[#2A2E38] rounded-sm shadow-2xl z-50 overflow-hidden"
        >
          {LANGUAGES.map((l) => (
            <button
              key={l.code}
              data-testid={`lang-option-${l.code}`}
              onClick={() => {
                setLang(l.code);
                setOpen(false);
              }}
              className={`w-full text-left px-3 py-2 text-xs flex items-center justify-between hover:bg-[#1C202B] ${
                l.code === lang ? "text-[#7C5CFF]" : "text-[#F4F1EB]"
              }`}
            >
              <span>{l.name}</span>
              <span className="font-mono text-[10px] text-[#6E7587]">{l.label}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
